export { default } from './QuemSomos';
